'use strict';

var React = require('react');

var SvgUnknownDeviceMajor = function SvgUnknownDeviceMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 2h1v-2h-1.5a1.5 1.5 0 0 0-1.5 1.5v1.5h2v-1zm4.685 10.502h2.136v-.141c.011-1.17.23-1.302 1.02-1.777l.238-.144c1.11-.664 1.805-1.57 1.805-2.952 0-2.04-1.588-3.488-3.894-3.488-2.113 0-3.93 1.193-3.99 3.487h2.267c.054-1.135.86-1.533 1.711-1.533.924 0 1.666.616 1.666 1.564 0 .845-.561 1.424-1.292 1.883-.102.064-.2.122-.293.178-.882.528-1.363.816-1.374 2.782v.14zm.979 4.34c.712 0 1.322-.591 1.328-1.328a1.342 1.342 0 0 0-1.328-1.316c-.737 0-1.334.592-1.328 1.316a1.32 1.32 0 0 0 1.328 1.328zm-5.664 1.158v-1h-2v1.5a1.5 1.5 0 0 0 1.5 1.5h1.5v-2h-1zm11 0h1v-1h2v1.5a1.5 1.5 0 0 1-1.5 1.5h-1.5v-2zm-11-7v4h-2v-4h2zm0-2v-4h-2v4h2zm14 2v4h-2v-4h2zm0-2v-4h-2v4h2zm-2-6v-1h-1v-2h1.5a1.5 1.5 0 0 1 1.5 1.5v1.5h-2z"
  }));
};

exports.SvgUnknownDeviceMajor = SvgUnknownDeviceMajor;
